"use client";

import Image from "next/image";

export default function Usp() {
  const items = [
    {
      title: "Certified Quality",
      icon: "/images/usp/high-quality.png",
    },
    {
      title: "Free Shipping",
      icon: "/images/usp/free-shipping.png",
    },
    {
      title: "Secure Payment",
      icon: "/images/usp/credit-card.png",
    },
    {
      title: "24/7 Support",
      icon: "/images/usp/24-hours-support.png",
    },
  ];

  return (
    <div className="grid grid-cols-4 gap-2 lg:gap-6 px-4 py-2 md:py-4 bg-black relative z-10">
      <div
        className="absolute w-full md:h-[250px] h-[100px] -top-[100px] md:-top-[250px] left-0 right-0"
        style={{
          background:
            "linear-gradient(0deg,rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 0) 40%)",
        }}
      ></div>
      {items.map((item, index) => (
        <div key={index}>
          <Image
            src={item.icon}
            alt={item.title}
            width={128}
            height={128}
            className="mx-auto mb-2 w-6 md:w-12"
          />
          <div className="md:uppercase text-center md:font-bold text-primary md:text-base text-[10px]">
            {item.title}
          </div>
        </div>
      ))}
    </div>
  );
}
